import React from 'react';
import clsx from 'clsx';

const ChrDivider = props => {
  
  return (
    <div className={clsx('d-flex align-items-center', props.additionalClasses, { 'py-2': !props.noPadding })}>
      <hr className='hr-line-solid flex-grow-1 no-margins' />
      { props.children }
      <hr className='hr-line-solid flex-grow-1 no-margins' />
    </div>
  );
};

export default ChrDivider;